import { HeaderContainer } from "./container";

export const Header = () => {
  return <HeaderContainer />;
};
